export default __webpack_public_path__ + "static/media/modal-dots-secondary.82c21d0a.svg";